// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Durations are mirrored by RETURN_MS / LAND_MS in index.js. */
.street-view-pegman-button {
  /* The press is a drag, not a scroll or a pinch, and must not select or offer to save the artwork. */
  touch-action: none;
  user-select: none;
  -webkit-user-select: none;
  -webkit-touch-callout: none;
  cursor: grab;
}
.street-view-pegman-button.is-dragging {
  cursor: grabbing;
}
.street-view-pegman-icon {
  position: relative;
  display: inline-block;
  vertical-align: middle;
  /* Out of the button while it is held: only the ring is left behind until it comes home. */
}
.street-view-pegman-icon img {
  position: absolute;
  inset: 0;
  width: 100%;
  height: 100%;
  -webkit-user-drag: none;
}
.is-empty .street-view-pegman-icon .street-view-pegman-icon-full {
  visibility: hidden;
}
.street-view-pegman-layer {
  position: fixed;
  inset: 0;
  /* Over the bottom sheet (antd drawers sit at 1000), so the figure is never hidden mid-drag. */
  z-index: 1100;
  overflow: hidden;
  /* Must stay transparent to hit-testing: the drop is resolved with elementFromPoint. */
  pointer-events: none;
}
/* Zero-sized anchors translated to a point on screen; their children are laid out around it. */
.street-view-pegman,
.street-view-pegman-target {
  position: absolute;
  left: 0;
  top: 0;
  width: 0;
  height: 0;
  will-change: transform;
}
.street-view-pegman-lean {
  position: absolute;
  left: 0;
  top: 0;
  /* Pivot on the feet, so leaning never moves the spot the figure will land on. */
  transform-origin: 0 0;
  transition: transform 120ms ease-out;
}
.street-view-pegman-figure {
  position: absolute;
  left: -14px;
  bottom: 0;
  width: 28px;
  height: 52px;
  transform-origin: 50% 100%;
  filter: drop-shadow(0 6px 4px rgba(0, 0, 0, 0.3));
  animation: street-view-pegman-lift 140ms ease-out;
  transition: transform 250ms ease-in-out, opacity 250ms ease-in-out;
  -webkit-user-drag: none;
}
/* Marks exactly where the feet are, which on touch is above the fingertip rather than under it. */
.street-view-pegman-shadow {
  position: absolute;
  left: -9px;
  top: -4px;
  width: 18px;
  height: 8px;
  border-radius: 50%;
  background: rgba(0, 0, 0, 0.3);
  transition: opacity 120ms ease-out;
}
/* The 360 point a drop would open. */
.street-view-pegman-target::after {
  content: '';
  position: absolute;
  left: -17px;
  top: -17px;
  width: 34px;
  height: 34px;
  box-sizing: border-box;
  border-radius: 50%;
  border: 3px solid var(--theme-primary);
  background: rgba(0, 136, 255, 0.25);
  box-shadow: 0 0 0 2px #FFFFFF, 0 2px 8px rgba(0, 0, 0, 0.3);
  animation: street-view-pegman-target 160ms ease-out;
}
.street-view-pegman-layer.is-landing .street-view-pegman {
  transition: transform 180ms ease-out;
}
.street-view-pegman-layer.is-landing .street-view-pegman-figure {
  transform: scale(0.8);
  transition-duration: 180ms;
}
.street-view-pegman-layer.is-landing .street-view-pegman-shadow {
  opacity: 0;
}
/* Floats back into the button, shrinking to the size of the person in its icon. */
.street-view-pegman-layer.is-returning .street-view-pegman {
  transition: transform 250ms cubic-bezier(0.2, 0.8, 0.2, 1);
}
.street-view-pegman-layer.is-returning .street-view-pegman-figure {
  transform: scale(var(--pegman-home-scale, 0.45));
}
.street-view-pegman-layer.is-returning .street-view-pegman-shadow {
  opacity: 0;
}
@keyframes street-view-pegman-lift {
  from {
    transform: scale(0.45);
  }
}
@keyframes street-view-pegman-target {
  from {
    transform: scale(0.4);
    opacity: 0;
  }
}
@media (prefers-reduced-motion: reduce) {
  .street-view-pegman-lean,
  .street-view-pegman-figure,
  .street-view-pegman-shadow,
  .street-view-pegman-layer .street-view-pegman,
  .street-view-pegman-target::after {
    transition: none !important;
    animation: none !important;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/StreetViewPegman/index.less"],"names":[],"mappings":"AAAA,+DAA+D;AAM/D;EAJE,oGAAoG;EAMlG,kBAAA;EACA,iBAAA;EACA,yBAAA;EACA,2BAAA;EACA,YAAA;AAJJ;AAMI;EACI,gBAAA;AAJR;AAQA;EACI,kBAAA;EACA,qBAAA;EACA,sBAAA;EANF,0FAA0F;AAC5F;AAEA;EAMQ,kBAAA;EACA,QAAA;EACA,WAAA;EACA,YAAA;EACA,uBAAA;AALR;AASI;EACI,kBAAA;AAPR;AAWA;EACI,eAAA;EACA,QAAA;EATF,8FAA8F;EAW5F,aAAA;EACA,gBAAA;EATF,sFAAsF;EAWpF,oBAAA;AATJ;AACA,+FAA+F;AAY/F;;EAEI,kBAAA;EACA,OAAA;EACA,MAAA;EACA,QAAA;EACA,SAAA;EACA,sBAAA;AAVJ;AAaA;EACI,kBAAA;EACA,OAAA;EACA,MAAA;EAXF,gFAAgF;EAa9E,qBAAA;EACA,oCAAA;AAXJ;AAcA;EACI,kBAAA;EACA,WAAA;EACA,SAAA;EACA,WAAA;EACA,YAAA;EACA,0BAAA;EACA,iDAAA;EACA,iDAAA;EACA,kEAAA;EACA,uBAAA;AAZJ;AACA,kGAAkG;AAelG;EACI,kBAAA;EACA,UAAA;EACA,SAAA;EACA,WAAA;EACA,WAAA;EACA,kBAAA;EACA,8BAAA;EACA,kCAAA;AAbJ;AACA,qCAAqC;AAiBjC;EACI,WAAA;EACA,kBAAA;EACA,WAAA;EACA,UAAA;EACA,WAAA;EACA,YAAA;EACA,sBAAA;EACA,kBAAA;EACA,sCAAA;EACA,mCAAA;EACA,2DAAA;EACA,mDAAA;AAfR;AAmBA;EAEQ,oCAAA;AAlBR;AAgBA;EAMQ,qBAAA;EACA,0BAAA;AAnBR;AAYA;EAWQ,UAAA;AApBR;AACA,kFAAkF;AAwBlF;EAEQ,0DAAA;AAvBR;AAqBA;EAMQ,gDAAA;AAxBR;AAkBA;EAUQ,UAAA;AAzBR;AA6BA;EACI;IACI,sBAAA;EA3BN;AACF;AA8BA;EACI;IACI,qBAAA;IACA,UAAA;EA5BN;AACF;AA+BA;EACI;;;;;IAKI,2BAAA;IACA,0BAAA;EA7BN;AACF","sourcesContent":["@theme-primary: var(--theme-primary);\n\n/* Durations are mirrored by RETURN_MS / LAND_MS in index.js. */\n@pegman-return: 250ms;\n@pegman-land: 180ms;\n\n.street-view-pegman-button {\n    /* The press is a drag, not a scroll or a pinch, and must not select or offer to save the artwork. */\n    touch-action: none;\n    user-select: none;\n    -webkit-user-select: none;\n    -webkit-touch-callout: none;\n    cursor: grab;\n\n    &.is-dragging {\n        cursor: grabbing;\n    }\n}\n\n.street-view-pegman-icon {\n    position: relative;\n    display: inline-block;\n    vertical-align: middle;\n\n    img {\n        position: absolute;\n        inset: 0;\n        width: 100%;\n        height: 100%;\n        -webkit-user-drag: none;\n    }\n\n    /* Out of the button while it is held: only the ring is left behind until it comes home. */\n    .is-empty & .street-view-pegman-icon-full {\n        visibility: hidden;\n    }\n}\n\n.street-view-pegman-layer {\n    position: fixed;\n    inset: 0;\n    /* Over the bottom sheet (antd drawers sit at 1000), so the figure is never hidden mid-drag. */\n    z-index: 1100;\n    overflow: hidden;\n    /* Must stay transparent to hit-testing: the drop is resolved with elementFromPoint. */\n    pointer-events: none;\n}\n\n/* Zero-sized anchors translated to a point on screen; their children are laid out around it. */\n.street-view-pegman,\n.street-view-pegman-target {\n    position: absolute;\n    left: 0;\n    top: 0;\n    width: 0;\n    height: 0;\n    will-change: transform;\n}\n\n.street-view-pegman-lean {\n    position: absolute;\n    left: 0;\n    top: 0;\n    /* Pivot on the feet, so leaning never moves the spot the figure will land on. */\n    transform-origin: 0 0;\n    transition: transform 120ms ease-out;\n}\n\n.street-view-pegman-figure {\n    position: absolute;\n    left: -14px;\n    bottom: 0;\n    width: 28px;\n    height: 52px;\n    transform-origin: 50% 100%;\n    filter: drop-shadow(0 6px 4px rgba(0, 0, 0, 0.3));\n    animation: street-view-pegman-lift 140ms ease-out;\n    transition: transform @pegman-return ease-in-out, opacity @pegman-return ease-in-out;\n    -webkit-user-drag: none;\n}\n\n/* Marks exactly where the feet are, which on touch is above the fingertip rather than under it. */\n.street-view-pegman-shadow {\n    position: absolute;\n    left: -9px;\n    top: -4px;\n    width: 18px;\n    height: 8px;\n    border-radius: 50%;\n    background: rgba(0, 0, 0, 0.3);\n    transition: opacity 120ms ease-out;\n}\n\n/* The 360 point a drop would open. */\n.street-view-pegman-target {\n    &::after {\n        content: '';\n        position: absolute;\n        left: -17px;\n        top: -17px;\n        width: 34px;\n        height: 34px;\n        box-sizing: border-box;\n        border-radius: 50%;\n        border: 3px solid @theme-primary;\n        background: rgba(0, 136, 255, 0.25);\n        box-shadow: 0 0 0 2px #FFFFFF, 0 2px 8px rgba(0, 0, 0, 0.3);\n        animation: street-view-pegman-target 160ms ease-out;\n    }\n}\n\n.street-view-pegman-layer.is-landing {\n    .street-view-pegman {\n        transition: transform @pegman-land ease-out;\n    }\n\n    .street-view-pegman-figure {\n        transform: scale(0.8);\n        transition-duration: @pegman-land;\n    }\n\n    .street-view-pegman-shadow {\n        opacity: 0;\n    }\n}\n\n/* Floats back into the button, shrinking to the size of the person in its icon. */\n.street-view-pegman-layer.is-returning {\n    .street-view-pegman {\n        transition: transform @pegman-return cubic-bezier(0.2, 0.8, 0.2, 1);\n    }\n\n    .street-view-pegman-figure {\n        transform: scale(var(--pegman-home-scale, 0.45));\n    }\n\n    .street-view-pegman-shadow {\n        opacity: 0;\n    }\n}\n\n@keyframes street-view-pegman-lift {\n    from {\n        transform: scale(0.45);\n    }\n}\n\n@keyframes street-view-pegman-target {\n    from {\n        transform: scale(0.4);\n        opacity: 0;\n    }\n}\n\n@media (prefers-reduced-motion: reduce) {\n    .street-view-pegman-lean,\n    .street-view-pegman-figure,\n    .street-view-pegman-shadow,\n    .street-view-pegman-layer .street-view-pegman,\n    .street-view-pegman-target::after {\n        transition: none !important;\n        animation: none !important;\n    }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
